import { Warning } from "@/icons"
import { Button, EmptyState, PageContainer } from "@/components/ui"
import { useNavigate } from "react-router-dom"

export function NotFound() {
  const navigate = useNavigate()
  return (
    <PageContainer>
      <EmptyState
        size="screen"
        icon={Warning}
        title="Página ou recurso não encontrado."
        action={
          <Button tone="secondary" fullWidth onClick={() => navigate("/")}>
            Voltar para a página inicial
          </Button>
        }
      />
    </PageContainer>
  )
}
